import React from 'react'
import { useTheme } from 'styled-components'
import { GridContainer, Grid } from 'unsemantic'
import { StyledGridContainerWrapper } from './GridContainerWrapper.styles'

interface GridContainerWrapperProps {
  pageBottomPadding?: boolean
  overflowX?: string
  topBorderColour?: string
}

const GridContainerWrapper: React.FC<GridContainerWrapperProps> = ({
  pageBottomPadding = false,
  overflowX,
  topBorderColour,
  children,
}) => {
  const theme = useTheme()

  return (
    <StyledGridContainerWrapper
      pageBottomPadding={pageBottomPadding}
      overflowX={overflowX}
      topBorderColour={
        topBorderColour ? topBorderColour : theme.inputBorderColour
      }
    >
      <GridContainer>
        <Grid
          desktop-prefix='20'
          desktop='60'
          desktop-suffix='20'
          tablet='100'
          parent
        >
          <Grid
            desktop='90'
            desktop-prefix='5'
            tablet='70'
            tablet-prefix='15'
            mobile='100'
            parent
          >
            {children}
          </Grid>
        </Grid>
      </GridContainer>
    </StyledGridContainerWrapper>
  )
}

export default GridContainerWrapper
